<template>

  <div class="filters">
    <div>
      <div class="autocomplete d-flex align-center">
        <v-select :items="types" v-model="filters.type" item-text="label" item-value="value" label="Type"></v-select>

        <div class="icon" v-if="filters.type">
          <v-btn text icon @click="filters.type = null">
            <v-icon>delete</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div>
      <issue-codes-select v-model="filters.issueCodes"></issue-codes-select>
    </div>

    <div>
      <asset-types-tree v-model="filters.assetTypes"></asset-types-tree>
    </div>

    <div>
      <assets-tree v-model="filters.assets"></assets-tree>
    </div>

    <div>
      <users-select v-model="filters.users" :clearable="true"></users-select>
    </div>

    <div>
      <v-switch v-model="filters.closed" :label="$t('issues.show-closed')"></v-switch>
    </div>
  </div>

</template>

<script>
  import {mapMutations, mapState} from 'vuex'
  import UsersSelect from '../../users/components/users-select'
  import AssetTypesTree from '../../asset-types/asset-types-tree'
  import AssetsTree from '../../assets/components/assets-tree'
  import IssueCodesSelect from '../../issue-codes/components/issue-codes-select'

  export default {
    name: 'issues-filters',

    data () {
      return {
        types: [
          { label: 'Maintenance', value: 'maintenance' },
          { label: 'Failure', value: 'failure' },
        ]
      }
    },

    computed: {
      ...mapState('filters/issues', [
        'filters'
      ]),
    },

    methods: {
      ...mapMutations('filters/issues', [
        'saveFilters'
      ])
    },

    watch: {
      filters: {
        deep: true,
        handler () {
          this.saveFilters(this.filters)
          this.$emit('change', this.filters)
        }
      }
    },

    components: {
      IssueCodesSelect,
      AssetTypesTree,
      AssetsTree,
      UsersSelect
    }
  }
</script>

<style scoped lang="scss">

</style>
